import { EventListSubmission } from './models';

export interface ListValidationIndicator {
    icon: string;
    color: string;
    labelKey: string;
}

/**
 * Errors outrank warnings. A submission with no stored summary reads as "unknown", never as
 * "clean" — either it predates summaries or it is a text list with no force to validate, and
 * both are cases where we genuinely do not know.
 */
export function getValidationIndicator(submission: EventListSubmission | undefined): ListValidationIndicator {
    // 'accepted' reports on its validation exactly as 'submitted' does: an organiser signing
    // a list off does not make it unsubmitted, and the separate "accepted by" line already
    // records the decision, so the indicator is free to keep saying what the list itself is.
    if (!submission || (submission.status !== 'submitted' && submission.status !== 'accepted')) {
        return { icon: 'ellipse-outline', color: 'medium', labelKey: 'GLOBAL.EVENTS.LIST_VALIDATION.NOT_SUBMITTED' };
    }

    const summary = submission.validationSummary;
    if (!summary) {
        return { icon: 'help-circle-outline', color: 'medium', labelKey: 'GLOBAL.EVENTS.LIST_VALIDATION.UNKNOWN' };
    }
    if (summary.errors > 0) {
        return { icon: 'alert-circle', color: 'danger', labelKey: 'GLOBAL.EVENTS.LIST_VALIDATION.ERRORS' };
    }
    if (summary.warnings > 0) {
        return { icon: 'warning', color: 'warning', labelKey: 'GLOBAL.EVENTS.LIST_VALIDATION.WARNINGS' };
    }
    return { icon: 'checkmark-circle', color: 'success', labelKey: 'GLOBAL.EVENTS.LIST_VALIDATION.CLEAN' };
}
